import React from 'react';
import { getForecastScoreLabel } from '../huntForecastUtils';

export default function ForecastScoreRing({ score, size = 56, className = '', showLabel }) {
  const value = Number.isFinite(Number(score)) ? Math.max(0, Math.min(100, Number(score))) : 0;
  const { label, tone } = getForecastScoreLabel(value);
  const radius = 40;
  const stroke = 9;
  const circumference = 2 * Math.PI * radius;
  const dash = `${(value / 100) * circumference} ${circumference}`;
  const labelVisible = showLabel != null ? Boolean(showLabel) : size >= 72;

  return (
    <div
      className={`hf-score-ring hf-score-ring--${tone} ${className}`.trim()}
      style={{ width: size, height: size }}
      aria-label={`Hunt score ${value || 'unknown'}, ${label}`}
    >
      <svg className="hf-score-ring__svg" viewBox="0 0 100 100" aria-hidden="true">
        <circle cx="50" cy="50" r={radius} fill="none" strokeWidth={stroke} className="hf-score-ring__track" />
        <circle
          cx="50"
          cy="50"
          r={radius}
          fill="none"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={dash}
          className="hf-score-ring__fill"
        />
      </svg>
      <span className="hf-score-ring__value">{value || '—'}</span>
      {labelVisible ? (
        <span className="hf-score-ring__label">{label}</span>
      ) : null}
    </div>
  );
}
